import React, { useState } from "react";
import ChrText from "../../../components/generic/Form/Basic/ChrText";
import i18n from "../../../utils/ChrI18n";

/*
props = {
  list: [],
  value: <>,
  searchable: <true || false>,
  searchingCondition: function
}
*/

const MINIMUM_COUNT_FOR_SEARCHING = 4;

const searchableCondition = (items, minCount) => items.length >= minCount;

export const useListSearch = props => {
  const {
    list = [],
    searchingCondition,
    listItemValueMapper,
    inputRef,
    searchable,
    formControlClass = "",
    formGroupClass = "",
    minCountForSearchable = MINIMUM_COUNT_FOR_SEARCHING
  } = props;

  const canSearch = searchable && searchableCondition(list, minCountForSearchable);

  const [value, setValue] = useState("");
  let filteredList = []

  if (canSearch) {
    filteredList = list.filter((listItem) => {
      if (!!searchingCondition) return searchingCondition(listItem, value);

      const listItemValue = (!!listItemValueMapper) ? listItemValueMapper(listItem) : listItem;
      return listItemValue.toLowerCase().indexOf(value.toLowerCase()) >= 0;
    });
  }

  const onChangeHandler = (_event, _childUId, childData) => {
    setValue(childData.value);
  };

  const [wrapperClassName, finalList] = canSearch ? ["", filteredList] : ["hide", list]

  const textComponent = (
    <span className={ wrapperClassName }>
      <ChrText
        data={ { value: value, placeholder: i18n.t("display_string.Search") } }
        onChange={ onChangeHandler }
        inputRef={ inputRef }
        formControlClass={ `cjs-list-search-input ${formControlClass}` }
        formGroupClass={ `${formGroupClass}` }
      />
    </span>
  );
  return [textComponent, finalList];
};
